import { Observable } from "rxjs";

export interface GeneralPackageType {
    id?: number;
    name: string;
    isActive: string;
    createdBy:number;
    createdDate:Date;
    createdIP?:string;
    updatedBy?: number,
    updatedDate?: Date,
    updatedIP?: string,
    tenantId:string;
    branchId:string;
      
}
export abstract class GeneralPackageTypeData {
    abstract list(url: string): Observable<GeneralPackageType[]>;
    abstract listStorageMst(url: string,tenantId:string,branchId:string): Observable<any[]>;
    abstract listStorageMstById(url: string,id:string): Observable<any[]>;
    abstract createStorageMst(url: string, data:any): Observable<any[]>;
    abstract create(url: string, data: GeneralPackageType): Observable<GeneralPackageType[]>;
    abstract update(url: string, data: GeneralPackageType): Observable<GeneralPackageType>;
    abstract updateStorageMstById(url: string,id:number,data: any): Observable<any[]>;
    abstract listStickerDet(url: string,forWhich:string,refNo:string,admId:number): Observable<any[]>;
    abstract listAbhaDet(url: string,valueSet:string): Observable<any[]>;
  }
